import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
  principalUserLevel: 'all',
  principals: [],
  assignedUsers: [],
  nonAssignedPanPrincipleUsers: [],
  nonAssignedUsers: []
};

const getters = {
  getPrincipalUserLevel: (state) => state.principalUserLevel,
  getPrincipals: (state) => state.principals,
  getAssignedUsers: (state) => state.assignedUsers,
  getNonAssignedPanPrincipleUsers: (state) => state.nonAssignedPanPrincipleUsers,
  getNonAssignedUsers: (state) => state.nonAssignedUsers
};

const actions = {
  async getPrincipals(context, data) {
      return axios.post(`${backendUrl()}/getPrincipals`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setPrincipals', response.data)
      })
  },
  async getAssignedUsers(context, data) {
      return axios.post(`${backendUrl()}/getAssignedUsers`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setAssignedUsers', response.data)
      })
  },
  async getNonAssignedPanPrincipleUsers(context, data) {
      return axios.post(`${backendUrl()}/getNonAssignedPanPrincipleUsers`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setNonAssignedPanPrincipleUsers', response.data)
      })
  },
  async getNonAssignedUsers(context, data) {
      return axios.post(`${backendUrl()}/getNonAssignedUsers`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setNonAssignedUsers', response.data)
      })
  },
  async addPrincipal(context, data) {
      await axios.post(`${backendUrl()}/addPrincipal`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async deletePrincipal(context, data) {
      await axios.post(`${backendUrl()}/deletePrincipal`,
      {
          sessionToken: vuecookie.get('token'),
          principal: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async withdrawPrincipleFromUser(context, data) {
      await axios.post(`${backendUrl()}/withdrawPrincipleFromUser`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async addPrincipleToUser(context, data) {
      await axios.post(`${backendUrl()}/addPrincipleToUser`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async disablePanPrincipleAccess(context, data) {
      return axios.post(`${backendUrl()}/disablePanPrincipleAccess`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async enablePanPrincipleAccess(context, data) {
      return axios.post(`${backendUrl()}/enablePanPrincipleAccess`,
      {
          sessionToken: vuecookie.get('token'),
          data: data
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  // NS-9814, Added function for principal delivery reports rule page, PW
  async getReportRulesPrinciples(context) {
    return axios.post(`${backendUrl()}/getReportRulesPrinciples`, null, {
        headers: { 'Authorization': "bearer " + vuecookie.get('token') }
    }).then(response => {
        return response.data
    })
  },
  async getPrincipleReportRules(context, data) {
    return axios.post(`${backendUrl()}/getPrincipleReportRules`, {
        id: data
    }, {
        headers: { 'Authorization': "bearer " + vuecookie.get('token') }
    }).then(response => {
        return response.data
    })
  },
  async updatePrincipleDeliveryReportRules(context, data) {
    return axios.post(`${backendUrl()}/updatePrincipleDeliveryReportRules`, data, {
        headers: { 'Authorization': "bearer " + vuecookie.get('token') }
    }).then(response => {
        context.dispatch('handleResponse', response, {root: true})
        return response.data
    })
  }
};

const mutations = {
  setPrincipalUserLevel: (state, principalUserLevel) => (state.principalUserLevel = principalUserLevel),
  setPrincipals: (state, principals) => (state.principals = principals),
  setAssignedUsers: (state, users) => (state.assignedUsers = users),
  setNonAssignedPanPrincipleUsers: (state, users) => (state.nonAssignedPanPrincipleUsers = users),
  setNonAssignedUsers: (state, users) => (state.nonAssignedUsers = users)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
